(() => {
  const root = document.querySelector('[data-mobile-menu]')
  const openButton = document.querySelector('[data-menu-open]')
  if (!root || !openButton || root.dataset.bound === 'true') return
  root.dataset.bound = 'true'

  const closeButton = root.querySelector('[data-menu-close]')
  document.body.appendChild(root)

  const setOpen = (open) => {
    root.hidden = !open
    openButton.setAttribute('aria-expanded', open ? 'true' : 'false')
    document.documentElement.style.overflow = open ? 'hidden' : ''
    const focusTarget = open ? closeButton : openButton
    if (focusTarget) focusTarget.focus()
  }

  openButton.addEventListener('click', () => {
    setOpen(root.hidden)
  })

  if (closeButton) {
    closeButton.addEventListener('click', () => setOpen(false))
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !root.hidden) setOpen(false)
  })

  const rootPath = (openButton.dataset.root || '/').replace(/\/$/, '') || '/'

  const isHome = () => {
    const path = window.location.pathname.replace(/\/$/, '') || '/'
    return path === rootPath || path === '/'
  }

  root.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', (event) => {
      const id = link.getAttribute('data-section')
      if (id && isHome()) {
        const target = document.getElementById(id)
        if (target) {
          event.preventDefault()
          setOpen(false)
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches
          window.requestAnimationFrame(() => {
            target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' })
            history.replaceState(null, '', `#${id}`)
          })
          return
        }
      }
      setOpen(false)
    })
  })
})()
